// src/pages/admin/AdminVendorsPage.tsx
import React from 'react';
import { useVendorVerifications, useApproveVendor, useRejectVendor } from '../hooks';
import { VendorVerificationCard } from '../components';
import { useToast } from '@/core/hooks/useToast';

export const AdminVendorsPage: React.FC = () => {
  const { data, isLoading } = useVendorVerifications({ status: 'pending' });
  const approveMutation = useApproveVendor();
  const rejectMutation = useRejectVendor();
  const { toast } = useToast();

  const handleApprove = (vendorId: string) => {
    approveMutation.mutate({ vendorId, notes: 'Approved by admin' }, {
      onSuccess: () => toast({ title: 'Vendor approved', variant: 'success' }),
    });
  };

  const handleReject = (vendorId: string) => {
    rejectMutation.mutate({ vendorId, reason: 'Does not meet requirements' }, {
      onSuccess: () => toast({ title: 'Vendor rejected', variant: 'success' }),
    });
  };

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-display font-semibold text-navy">Vendor Verification</h1>
        <p className="text-warm-gray">Review and verify vendor applications</p>
      </div>

      {isLoading ? (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {[...Array(4)].map((_, i) => (
            <div key={i} className="h-48 bg-gray-100 animate-pulse rounded-xl" />
          ))}
        </div>
      ) : data?.items.length === 0 ? (
        <div className="bg-white rounded-xl border border-gray-200 p-12 text-center">
          <svg className="w-12 h-12 mx-auto text-sage mb-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          <p className="text-navy font-medium">All caught up!</p>
          <p className="text-warm-gray">No pending vendor verifications</p>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {data?.items.map((vendor) => (
            <VendorVerificationCard
              key={vendor.id}
              vendor={vendor}
              onApprove={() => handleApprove(vendor.id)}
              onReject={() => handleReject(vendor.id)}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default AdminVendorsPage;



